<script setup lang="ts">
import { computed, inject, type CSSProperties, type VNodeChild } from 'vue'
import RenderContent from '../internal/RenderContent'
import { descriptionsKey } from './context'

const props = withDefaults(defineProps<{ label?: VNodeChild; span?: number; labelStyle?: CSSProperties; contentStyle?: CSSProperties }>(), { span: 1 })
const context = inject(descriptionsKey)
if (!context) throw new Error('RrDescriptionsItem 必须位于 RrDescriptions 内')
const span = computed(() => Math.max(1, Math.min(context.value.column, Math.trunc(props.span))))
</script>

<template>
  <div class="rr-descriptions__item" :style="{ gridColumn: `span ${span}` }"><dt class="rr-descriptions__label" :class="{ 'has-colon': context?.colon }" :style="[context?.labelStyle, labelStyle]"><slot name="label"><RenderContent :value="label" /></slot></dt><dd class="rr-descriptions__content" :style="[context?.contentStyle, contentStyle]"><slot>—</slot></dd></div>
</template>
